module.exports = __webpack_public_path__ + "static/media/banner_home_260x225_vx_dobro.8f0973c4.jpg";